<template>
  <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
    <canvas :id="uuid" :width="size.width" :height="size.height"/>
  </div>
</template>

<script>
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Colorize } from "@/libs/colorizer";

export default {
  name: "b5d7b1d3-0d39-11eb-8114-00155d01060e",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      canvas: null,
      graph: null,
      old: null,
      count: [],
      type: [],
    }
  },
  computed: {
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  methods: {
    resave_data: function () {
      this.report_data = this.report_data.map(el => {
        return parseInt(el['КоличествоТСОВНаряде'])
      })
      this.update_chart()
    },
    back_data: function () {
      this.report_data = this.old
    },
    Colorize,
    make_chart: function () {
      this.update_data()
      if (this.canvas) {
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ChartDataLabels],
          data: {
            labels: this.type,
            datasets: [{
              data: this.count,
              maxBarThickness: 800,
            }]
          },
          options: {
            layout: {
              padding: {
                top: 25
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Кол-во элементов ТСО'
                }
              }
            },
            plugins: {
              datalabels: {
                anchor: 'end',
                clamp: true,
                align: 'end'
              },
              legend: {
                display: false
              }
            }
          }
        });
      }
    },
    update_data: function () {
      this.count = []
      this.type = []
      for (let i =0; i < this.chart.report_data.length; i++) {
        this.type.push(this.chart.report_data[i]["Тип"])
        this.count.push(this.chart.report_data[i]["КоличествоТСОВНаряде"])
      }
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    }
  }
}
</script>

<style scoped>

</style>

<!--
methods: {
make_chart: function () {

},
update_data: function () {

},
update_chart: function () {

}
},

-->
